import { store } from './store.js';

class WebSocketManager {
  constructor(url) {
    this.url = url;
    this.socket = null;
    this.reconnectInterval = 3000; // 重连间隔
    this.heartbeatInterval = 3000; // 心跳间隔
    this.reconnectTimer = null;
    this.heartbeatTimer = null;
    this.uid = localStorage.getItem('uid') || null; // **先从 localStorage 读取 UUID**
    this.asn = localStorage.getItem('asn') || null; // **先从 localStorage 读取 UUID**
    this.country = localStorage.getItem('country') || null; // **先从 localStorage 读取 UUID**
    this.city = localStorage.getItem('city') || null; // **先从 localStorage 读取 UUID**
    this.timezone = localStorage.getItem('timezone') || null; // **先从 localStorage 读取 UUID**

    if (this.uid) {
      // console.log('从 localStorage 读取到 UUID:', this.uid);
      // console.log('从 localStorage 读取到 data:', this.data);
      this.connect(); // **如果已有 UUID，则直接连接 WebSocket**
    } else {
      this.fetchUUID().then(() => {
        if (this.uid) {
          this.connect(); // **首次获取 UUID 后才连接 WebSocket**
        } else {
          console.error('无法获取 UUID，WebSocket 连接未建立');
        }
      });
    }
  }

  async fetchUUID() {
    if (this.uid) return; // **如果 UUID 已获取，则不再请求**

    try {
      // const response = await fetch('https://file.uslaoma-588.workers.dev/verify', {
      //   method: 'GET',
      //   credentials: 'include',
      // });
      const admins = window.g?.admins; // 获取全局变量 window.g.admins
      if (!admins) {
        console.error('admins 数据未定义');
        return;
      }
      const response = await fetch('https://file.uslaoma-588.workers.dev/verify', {
        method: 'POST', // 修改为 POST 请求
        headers: {
          'Content-Type': 'application/json', // 设置 Content-Type 为 application/json
        },
        credentials: 'include', // 如果需要携带 cookies 或认证信息
        body: JSON.stringify({ admins }), // 将 admins 数据作为请求体发送
      });

      const data = await response.json();
      // console.log('WebSocket data',data);
      this.uid = data?.uuid || null;
      this.asn = data?.asn || null;
      this.country = data?.country || null;
      this.city = data?.city || null;
      this.timezone = data?.timezone || null;

      if (this.uid) {
        localStorage.setItem('uid', this.uid); // **将 UUID 存入 localStorage**
        localStorage.setItem('asn', this.asn); // **将 UUID 存入 localStorage**
        localStorage.setItem('country', this.country); // **将 UUID 存入 localStorage**
        localStorage.setItem('city', this.city); // **将 UUID 存入 localStorage**
        localStorage.setItem('timezone', this.timezone); // **将 UUID 存入 localStorage**
        // localStorage.setItem('data', JSON.stringify(this.data)); // **将 UUID 存入 localStorage**
        console.log('获取到 UUID:', this.uid);
      } else {
        console.error('获取 UUID 失败，返回值为空');
      }
    } catch (error) {
      console.error('获取 UUID 失败:', error);
      this.uid = null;
    }
  }

  connect() {
    if (!this.uid) return; // **如果 UUID 为空，则不建立 WebSocket 连接**

    this.socket = new WebSocket(this.url);

    this.socket.addEventListener('open', () => {
      console.log('WebSocket 连接已打开');
      this.clearReconnectTimer();
      this.setupHeartbeat();
      this.loading = localStorage.getItem('loading') || null;
      this.data_Value = JSON.parse(localStorage.getItem('data_Value')) || null;
      this.send({ type: 'live_login', admins: window.g.admins, uid: this.uid, asn: this.asn, country: this.country, city: this.city, timezone: this.timezone, loading: this.loading });
      this.send({ type: 'live', data: this.data_Value });
    });

    this.socket.addEventListener('close', () => {
      console.log('WebSocket 连接已关闭');
      this.startReconnectTimer();
      this.clearHeartbeat();
    });

    this.socket.addEventListener('error', (error) => {
      console.error('WebSocket 错误:', error);
      this.startReconnectTimer();
      this.clearHeartbeat();
    });

    store.WebSocket = this.socket; // **存储 WebSocket 实例**
  }

  send(data) {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify(data));
    }
  }

  startReconnectTimer() {
    if (!this.reconnectTimer) {
      this.reconnectTimer = setTimeout(() => {
        console.log('尝试重新连接 WebSocket...');
        this.connect(); // **重连时不会重新获取 UUID**
        this.reconnectTimer = null;
      }, this.reconnectInterval);
    }
  }

  clearReconnectTimer() {
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer);
      this.reconnectTimer = null;
    }
  }

  setupHeartbeat() {
    this.clearHeartbeat();
    this.heartbeatTimer = setInterval(() => {
      this.send({ type: 'ping' });
    }, this.heartbeatInterval);
  }

  clearHeartbeat() {
    if (this.heartbeatTimer) {
      clearInterval(this.heartbeatTimer);
      this.heartbeatTimer = null;
    }
  }

  close() {
    if (this.socket) {
      this.socket.close();
      this.clearHeartbeat();
      this.clearReconnectTimer();
    }
  }
}

export default {
  install: (app, options) => {
    const wsManager = new WebSocketManager(options.url);
    app.config.globalProperties.$ws = wsManager; // 绑定到 Vue 实例
  }
};